import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as variableOverrides from '../../../../../../variable-overrides'
import type { Feature } from '../feature'

/**
 * Put variable definitions for widget when widget lookup selection is changed
 */
export const putWidgetVariableDefinitions = store.effects.create(
  (feature: Feature, variablesFeature: variableOverrides.Feature) =>
    feature.selectors.allWidgetRenderings.asObservable.pipe(
      rxjs.switchMap(widgetRenderings =>
        rxjs.from(
          widgetRenderings.flatMap(rendering => {
            if (!rendering.id || !rendering.variables?.length) {
              // We do not need to put definitions for renderings without IDs or
              // without variables
              return []
            }
            return variablesFeature.actions.putDefinitions
              .from('putWidgetVariableDefinitions (effect)')
              .create({
                holder: { widget: { widgetId: rendering.id } },
                variables: rendering.variables,
              })
          }),
        ),
      ),
    ),
)
